module.exports = __webpack_public_path__ + "img/cz.ce3d2422.svg";